<template>
    <div
        v-if="user"
        class="avatar"
        :class="{medium: size === 'medium', small: size === 'small'}"
    >
        <img
            v-if="user?.portrait" :src="`${portrait_url}`"
            alt=""
        >
        <span v-else>{{ user?.username?.[0].toUpperCase() || "" }}</span>
    </div>
</template>

<script>
    import {baseURL} from "@/mixins/helpers";

    export default {
        name: "UserAvatar",
        props: {
            user: null,
            size: String, // "medium" | "small"
        },
        computed: {
            portrait_url() {
                return `${baseURL()}${this.user.portrait}`
            }
        }
    };
</script>

<style scoped lang="scss">
    .avatar {
        flex-shrink: 0;
        //width: 30px;
        //height: 30px;
        & > * {
            height: 30px;
            width: 30px;
            line-height: 30px;
            display: block;
            object-fit: cover;
            border-radius: 50%;
            background-color: #fff;
            text-align: center;
            color: black;
        }

        &.large > * {
            height: 30px;
            width: 30px;
            line-height: 22px;
            font-size: 12px;
        }

        &.medium > * {
            height: 22px;
            width: 22px;
            line-height: 22px;
            font-size: 12px;
        }

        &.small > * {
            height: 18px;
            width: 18px;
            line-height: 18px;
        }
    }
</style>
